import { useContext, useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'

import ColorPaletteComponent from './ColorPaletteComponent'
import { notifyErrorCustom } from '../../../utils/notify'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { FooterNaviBarOnlyNext } from '../../../components/FooterNaviBarOnlyNext'
import ColorPaletteComponentMobile from './ColorPaletteComponentMobile'
import { EventMapService, OrchestratorColorsService } from '../../../services'

import PropTypes from 'prop-types'
// import { TourGuide } from '../../../components/TourGuide'
// import {PalleteColorNextStepSteps, PalleteColorSelectionSteps, PalleteColorsSelectedContainerSteps, PalleteColorsSelectedSteps} from './TourGuideSteps'
import { ChatTimerContext } from '../../../contexts/ChatTimerContext/ChatTimerContext'
import { useGoogleAdsTracking } from '../../../utils/googleAdsTracking'

const STEPS = {
  STEP_NINCHE: 'stepNinche',
}
function StepColorPalette({ setStep, colorsArray, setColorsArray }) {
  // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  const [colors, setColors] = useState(['', '', ''])
  const { updateUrlWithColorPaletteEvent } = useGoogleAdsTracking()

  const eventsRegisteredRef = useRef(false)

  const registerEvent = async (data) => {
    await EventMapService.postEventMap(data)
  }

  //hook para renderizar o chat em determinado tempo
  const {
    restartTimer,
    shouldRenderChat,
    setShouldRenderChat,
    clearTimer,
    setTime
  } = useContext(ChatTimerContext)

  const chatTime = 101000
  useEffect(() => {
    setTime(chatTime)
  }, [])


  //renderiza os tour guides
  // const [renderTourGuide, setRenderTourGuide] = useState({
  //   // a ordem do tutorial é setada conforme a ordem desses itens do objeto
  //   collorPickerTour:false,
  //   collorsSelectionTour:false,
  //   afterSelectedTour:false,
  //   nextStepTour:false
  // })

  // const verifyStartTutorial = () =>{
  //   if(localStorage.getItem('showPalleteTutorial') !== 'false')
  //     setRenderTourGuide((prev)=>({...prev, collorPickerTour:true}))
  // }

  // const handleStartColorSelectionTutorial = () => {
  //   if(colors.length > 0 && renderTourGuide.collorPickerTour)
  //     setRenderTourGuide((prev)=>({...prev, collorsSelectionTour:true }))
  // }

  // const handleStartShowColorsSelectedTutorial = () => {
  //   if(renderTourGuide.collorsSelectionTour)
  //     setRenderTourGuide((prev)=>({...prev, afterSelectedTour:true }))
  // }

  // const handleNextStepsTutorial = () => {
  //   if(colors.length >= 3 && renderTourGuide.afterSelectedTour){
  //     setRenderTourGuide((prev)=>({...prev, nextStepTour:true }))
  //     localStorage.setItem('showPalleteTutorial', false)
  //   }

  // }

  useEffect(() => {
    loadBranding()
    setShouldRenderChat(true)
  }, [])


  useEffect(() => {
    shouldRenderChat && restartTimer()
  }, [colors, shouldRenderChat])


  const loadBranding = async () => {
    if (colorsArray?.primaryColor) {
      const values = []
      if (colorsArray?.primaryColor) {
        values.push(colorsArray?.primaryColor)
      }
      if (colorsArray?.secondaryColor) {
        values.push(colorsArray?.secondaryColor)
      }
      if (colorsArray?.tertiaryColor) {
        values.push(colorsArray?.tertiaryColor)
      }
      if (colorsArray?.complementaryColor1) {
        values.push(colorsArray?.complementaryColor1)
      }
      if (colorsArray?.complementaryColor2) {
        values.push(colorsArray?.complementaryColor2)
      }
      while (values.length < 3) {
        values.push('')
      }
      setColors(values)
    }
  }

  const hexToRgb = (hexValue) => {
    // Remove o "#" se estiver presente
    const cleanHex = hexValue.replace('#', '')

    if (cleanHex.length !== 6) {
      return 'Formato inválido'
    }

    const r = parseInt(cleanHex.substring(0, 2), 16)
    const g = parseInt(cleanHex.substring(2, 4), 16)
    const b = parseInt(cleanHex.substring(4, 6), 16)

    return `(${r}, ${g}, ${b})`
  }

  const rgbToHex = (rgbValue) => {
    // Extrai os números da string rgb usando regex
    const result = rgbValue.match(/\d+/g)

    if (!result || result.length !== 3) {
      return 'Formato inválido'
    }

    const r = parseInt(result[0], 10)
    const g = parseInt(result[1], 10)
    const b = parseInt(result[2], 10)

    if ([r, g, b].some((v) => isNaN(v) || v < 0 || v > 255)) {
      return 'Valores fora do intervalo RGB'
    }

    const toHex = (num) => num.toString(16).padStart(2, '0')

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`
  }

  const handleNavigate = async (type) => {
    if (type === 'next') {
      // console.log('Coloors', colors[0])
      let generateColorReturn

      if (colors.length < 3) {
        notifyErrorCustom(t('fast_publishing_choose_at_least_3_colors'))
        return
      }

      if (colors.length === 3 || colors.length === 4) {
        const bodyGenerateArt = {
          color_palette_1: hexToRgb(colors[0]),
          color_palette_2: hexToRgb(colors[1]),
          color_palette_3: hexToRgb(colors[2]),
          color_palette_4: colors[3] ? hexToRgb(colors[3]) : '',
          color_palette_5: '',
        }

        // generateColorReturn = await PythonService.postGenerateNewColorPallet(
        //   bodyGenerateArt
        // )

        generateColorReturn = await OrchestratorColorsService.generateComplementarColors(
          bodyGenerateArt
        )



      }

      const hasEmptyField = colors.some((item) => !item)

      if (hasEmptyField) {
        notifyErrorCustom(t('fast_publishing_one_field_is_empty'))
        return
      }

      let colorsArray = {
        primaryColor: colors[0],
        secondaryColor: colors[1],
        tertiaryColor: colors[2],
        complementaryColor1: colors[3]
          ? colors[3]
          : rgbToHex(generateColorReturn?.data?.color_palette_4),
        complementaryColor2: colors[4]
          ? colors[4]
          : rgbToHex(generateColorReturn?.data?.color_palette_5),

        fontTitleId: '',

        fontSubtitleId: '',

        fontTextId: '',

        fontTitleByUploaded: false,
        fontSubtitleByUploaded: false,
        fontTextByUploaded: false,
      }

      if (!eventsRegisteredRef.current) {
        const dataEvenProgressBranding = {
          event: 'parametrization_progress_updated',
          eventData: {
            step: 'ColorPalette',
            percentComplete: '50%',
          },
        }
        await registerEvent(dataEvenProgressBranding)
        eventsRegisteredRef.current = true
      }

      setColorsArray(colorsArray)

      updateUrlWithColorPaletteEvent()

      handleStepClearTimer(STEPS.STEP_NINCHE)
    }
  }

  const [exibeColorPallet, setExibeColorPallet] = useState(false)
  const [indexColor, setIndexColor] = useState(0)

  const { t } = useTranslation()

  const handleStepClearTimer = (step) => {
    clearTimer()
    setStep(step)
  }

  // const handleFinish = (eventTourGuide, callback) => {
  //   if(eventTourGuide === 'skipped'){
  //     localStorage.setItem('showPalleteTutorial', false)
  //     if(callback) callback()
  //   }else{
  //     if(callback) callback()
  //   }

  // }

  return (
    <motion.div
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      exit={{ x: '-100vw' }}
      transition={{ type: 'tween', duration: 0.5 }}
      // onAnimationComplete={()=>verifyStartTutorial()}
      style={{
        flex: 1,
        marginRight: 20,
        display: 'flex',
        zIndex: 1003
      }}
    >
      {/* {
        renderTourGuide.collorPickerTour && (
          <TourGuide
            steps={PalleteColorSelectionSteps
              .map((e, i)=>(
                {...e, content:t(e.content), 
                  locale:{
                    next:t(e.locale.next),
                    last:t(e.locale.last),
                    back:t(e.locale.back),
                    close:t(PalleteColorSelectionSteps.length === i + 1 ?  e.locale.close : e.locale.next),
                    skip:t(e.locale.skip)
                  }}
              ))} 
            isOpen={renderTourGuide.collorPickerTour} 
            onFinish={handleFinish}/>
        )}

      {renderTourGuide.collorsSelectionTour && (
        <TourGuide 
          steps={PalleteColorsSelectedSteps.map((e, i)=>(
            {...e, content:t(e.content), 
              locale:{
                next:t(e.locale.next),
                last:t(e.locale.last),
                back:t(e.locale.back),
                close:t(PalleteColorsSelectedSteps.length === i + 1 ?  e.locale.close : e.locale.next),
                skip:t(e.locale.skip)
              }}
          ))} 
          isOpen={renderTourGuide.collorsSelectionTour} 
          onFinish={handleFinish}/>
      )}

      {renderTourGuide.afterSelectedTour && (
        <TourGuide 
          steps={PalleteColorsSelectedContainerSteps.map((e, i)=>(
            {...e, content:t(e.content), 
              locale:{
                next:t(e.locale.next),
                last:t(e.locale.last),
                back:t(e.locale.back),
                close:t(PalleteColorsSelectedContainerSteps.length === i + 1 ?  e.locale.close : e.locale.next),
                skip:t(e.locale.skip)
              }}
          ))} 
          isOpen={renderTourGuide.afterSelectedTour} 
          onFinish={handleFinish}/>
      )}

      {renderTourGuide.nextStepTour && (
        <TourGuide
          steps={PalleteColorNextStepSteps.map((e, i) =>(
            {...e, content:t(e.content), 
              locale:{
                next:t(e.locale.next),
                last:t(e.locale.last),
                back:t(e.locale.back),
                close:t(PalleteColorNextStepSteps.length === i + 1 ?  e.locale.close : e.locale.next),
                skip:t(e.locale.skip)
              }}
          ))} 
          isOpen={renderTourGuide.nextStepTour} 
          onFinish={handleFinish}/>
      )} */}

      <div
        className={styles.box_step}
        style={{ flex: 1 }}
      >
        <div className={styles.box_page}>
          {/* <div
            className={styles.leftContent}
            style={{
              background: `url(${CardCentralLogin})`,
              backgroundRepeat: 'no-repeat',
              objectFit: 'cover',
            }}
          >
            <div className={styles.postei_logo_field}>
              <img
                src={xamaLogoWhite}
                alt="posteiLogo"
                style={{ height: 40, width: 150 }}
              />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                alignItems: 'center',
              }}
            >
              <div className={styles.sign_box_header}>
                <h1>{t('fast_publishing_logo_title')}</h1>
                <p>
                  {t('fast_publishing_logo_content')} ✨
                </p>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '300px',
                  gap: '15px',
                }}
              >
                <button className={styles.button_create_account}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="25" height="25" rx="12.5" fill="#000" />
                    <path
                      d="M12.5122 19V7.516L10.0732 8.983V7.498L12.5122 6.04H13.8532V19H12.5122Z"
                      fill="white"
                    />
                  </svg>
                  {t('fast_publishing_add_your_colors_btn')}
                </button>
                <button className={styles.button_select_plan}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="25" height="25" rx="12.5" fill="#4E4E4E" />
                    <path
                      d="M8.7375 18.492L8.7455 17.42L13.9535 12.716C14.4015 12.3107 14.6975 11.9267 14.8415 11.564C14.9908 11.196 15.0655 10.812 15.0655 10.412C15.0655 9.93733 14.9535 9.508 14.7295 9.124C14.5055 8.74 14.2042 8.436 13.8255 8.212C13.4468 7.98267 13.0228 7.868 12.5535 7.868C12.0628 7.868 11.6255 7.98533 11.2415 8.22C10.8575 8.45467 10.5535 8.764 10.3295 9.148C10.1108 9.532 10.0042 9.95067 10.0095 10.404H8.8095C8.8095 9.70533 8.97483 9.07867 9.3055 8.524C9.63617 7.96933 10.0842 7.53467 10.6495 7.22C11.2148 6.9 11.8548 6.74 12.5695 6.74C13.2682 6.74 13.8948 6.90533 14.4495 7.236C15.0095 7.56133 15.4495 8.004 15.7695 8.564C16.0948 9.11867 16.2575 9.73733 16.2575 10.42C16.2575 10.9 16.1988 11.324 16.0815 11.692C15.9695 12.0547 15.7908 12.3933 15.5455 12.708C15.3055 13.0173 14.9988 13.3373 14.6255 13.668L10.0015 17.844L9.8175 17.364H16.2575V18.492H8.7375Z"
                      fill="white"
                    />
                  </svg>
                  {t('fast_publishing_define_your_niche')}
                </button>
              </div>
            </div>
          </div> */}
          {/* <div style={{ width:500}}/> */}
          <div className={styles.rightContent}>
            <div className={styles.rightTitleContent}>
              <h1 >
                {t('fast_publishing_color_palette')}
              </h1>
              <h3>
                {t('fast_publishing_choose_3_at_5_colors')}
              </h3>
            </div>
            <div id='pallete-color-container'
              style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', width: '100%', marginLeft: '80px' }}
            >
              <ColorPaletteComponent
                onClickApplyButton={() => {
                  // handleStartShowColorsSelectedTutorial()
                  // handleNextStepsTutorial()
                }}
                onMouseUpPallete={() => {
                  restartTimer()
                  // handleStartColorSelectionTutorial()
                }}
                colors={colors}
                setColors={setColors}
              />
            </div>
            <FooterNaviBarOnlyNext next={() => handleNavigate('next')} />
          </div>
        </div>
      </div>

      {exibeColorPallet && (
        <ColorPaletteComponentMobile
          colors={colors}
          setColors={setColors}
          setExibeColorPallet={setExibeColorPallet}
          indexColor={indexColor}
        />
      )}
    </motion.div>
  )
}

StepColorPalette.propTypes = {
  setStep: PropTypes.func,
  colorsArray: PropTypes.array,
  setColorsArray: PropTypes.func
}

export default StepColorPalette
